module.exports = __webpack_public_path__ + "static/media/brand-logo-inverse-dark.d115657e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-logo-inverse-dark.png
// module id = 13
// module chunks = 1